/* Choix du point relais AVANT le paiement, depuis le tiroir panier.
 *
 * Pourquoi ici : la boutique est en formule Basic, il n'y a donc pas
 * d'extension possible sur la page de paiement. Le seul endroit ou le client
 * peut choisir son point relais avant de payer, c'est le panier.
 *
 * Pourquoi c'est facultatif et replie par defaut : le tunnel de commande perd
 * deja des clients, on n'ajoute pas une etape obligatoire. Celui qui ne fait
 * rien garde le fonctionnement actuel, et l'expedition retient pour lui le
 * point le plus proche de son adresse (correctif du 21/08/2026, incident
 * #1235 : un client avait recu son colis a 40 km de chez lui).
 *
 * Le choix est enregistre dans l'attribut de panier « Point relais », sous la
 * forme « <id sendcloud> | <libelle> ». Il arrive sur la commande Shopify en
 * note_attributes, et le failover s'en sert tel quel.
 *
 * Ce fichier est autonome : s'il echoue, le panier fonctionne comme avant.
 */
(function () {
  'use strict';

  var API = 'https://mail.vanilledesire.com/points-relais';
  var ATTR = 'Point relais';
  var ATTR_PAYS = 'Point relais pays';
  var enCours = null;

  function paysCourant() {
    return String((window.Shopify && window.Shopify.country) || '').toUpperCase();
  }

  function urlPanier(fichier) {
    return (((window.Shopify || {}).routes || {}).root || '/') + fichier;
  }

  /* Les pays ou une methode « Livraison en Point Relais » existe reellement
   * dans les profils de livraison Shopify (releve du 10/09/2026, profils
   * « General profile » et « Openclaw Shipping », identiques). Ailleurs, la
   * Suisse en tete, seule la livraison a domicile part : proposer un point
   * relais, ou pire afficher « point relais choisi », est un mensonge.
   * A tenir a jour si une zone gagne ou perd sa methode relais. */
  var PAYS_RELAIS = ['AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR',
    'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MC', 'NL', 'PL', 'PT', 'SE',
    'SI', 'SK'];

  function paysAvecRelais() {
    return PAYS_RELAIS.indexOf(paysCourant()) !== -1;
  }

  var LANGUES = {
    fr: {
      intro: 'Livraison en point relais : nous retenons le plus proche de votre adresse.',
      choisir: 'Choisir moi-même',
      placeholder: 'Code postal ou ville',
      chercher: 'Chercher',
      recherche: 'Recherche en cours...',
      rien: 'Aucun point relais trouvé pour cette adresse.',
      erreur: 'Recherche indisponible pour le moment.',
      choisi: 'Point relais choisi :',
      modifier: 'Modifier',
      retirer: 'Revenir au plus proche',
      consigne: 'consigne automatique',
      commerce: 'commerçant'
    },
    en: {
      intro: 'Pickup point delivery: we select the one closest to your address.',
      choisir: 'Choose it myself',
      placeholder: 'Postcode or town',
      chercher: 'Search',
      recherche: 'Searching...',
      rien: 'No pickup point found for this address.',
      erreur: 'Search unavailable right now.',
      choisi: 'Chosen pickup point:',
      modifier: 'Change',
      retirer: 'Back to the closest one',
      consigne: 'automated locker',
      commerce: 'shop'
    },
    es: {
      intro: 'Entrega en punto de recogida: elegimos el más cercano a su dirección.',
      choisir: 'Elegir yo mismo',
      placeholder: 'Código postal o ciudad',
      chercher: 'Buscar',
      recherche: 'Buscando...',
      rien: 'No se ha encontrado ningún punto para esa dirección.',
      erreur: 'Búsqueda no disponible por ahora.',
      choisi: 'Punto de recogida elegido:',
      modifier: 'Cambiar',
      retirer: 'Volver al más cercano',
      consigne: 'taquilla automática',
      commerce: 'comercio'
    }
  };

  var lang = (document.documentElement.getAttribute('lang') || 'fr').slice(0, 2).toLowerCase();

  /* Libelles de de, it, nl, ja, ko, zh-CN et zh-TW : portes par Liquid en
   * sections.vd_relais.* (locales/*.json) et transmis via l'attribut
   * data-vd-pr-i18n de l'ancre [data-vd-cart-pro] (10/09/2026). LANGUES
   * ci-dessus reste le filet de secours si l'attribut manque ou est
   * invalide : fr, en, es restent alors corrects comme avant. */
  function libellesDepuisLiquid(ancre) {
    var brut = ancre && ancre.getAttribute('data-vd-pr-i18n');
    if (!brut) return null;
    try {
      var d = JSON.parse(brut);
      return d && d.intro ? d : null;
    } catch (e) {
      return null;
    }
  }

  var CSS = [
    '.vd-pr{margin:10px 0 4px;font-size:13px;line-height:1.45}',
    '.vd-pr__intro{margin:0;opacity:.85}',
    '.vd-pr__lien{background:none;border:0;padding:0;margin-left:4px;font:inherit;',
    'text-decoration:underline;cursor:pointer;color:inherit}',
    '.vd-pr__form{display:flex;gap:6px;margin-top:8px}',
    '.vd-pr__form input{flex:1 1 auto;min-width:0;padding:7px 9px;font:inherit;',
    'border:1px solid rgba(128,128,128,.45);border-radius:4px;background:transparent;color:inherit}',
    '.vd-pr__form button{padding:7px 12px;font:inherit;cursor:pointer;border-radius:4px;',
    'border:1px solid rgba(128,128,128,.45);background:transparent;color:inherit}',
    '.vd-pr__liste{list-style:none;margin:8px 0 0;padding:0;max-height:190px;overflow:auto}',
    '.vd-pr__liste li{margin:0 0 4px}',
    '.vd-pr__pt{display:block;width:100%;text-align:left;padding:7px 9px;font:inherit;',
    'cursor:pointer;border:1px solid rgba(128,128,128,.3);border-radius:4px;',
    'background:transparent;color:inherit}',
    '.vd-pr__pt:hover{border-color:currentColor}',
    '.vd-pr__pt b{display:block;font-weight:600}',
    '.vd-pr__pt span{opacity:.75;font-size:12px}',
    '.vd-pr__msg{margin:8px 0 0;opacity:.75}',
    '.vd-pr__actif{margin:0;padding:8px 10px;border:1px solid rgba(128,128,128,.4);',
    'border-radius:4px}'
  ].join('');

  function styles() {
    if (document.getElementById('vd-pr-css')) return;
    var s = document.createElement('style');
    s.id = 'vd-pr-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function ech(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  function enregistrer(valeur) {
    var attrs = {};
    attrs[ATTR] = valeur;
    attrs[ATTR_PAYS] = valeur ? paysCourant() : '';
    var express = document.querySelector('.vd-cart-drawer__express');
    var etaitInerte = express && express.inert;
    if (express) express.inert = true;
    var requete = fetch(urlPanier('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update ' + r.status);
      return r.json();
    }).then(function (cart) {
      var a = (cart && cart.attributes) || {};
      if ((a[ATTR] || '') !== valeur || (a[ATTR_PAYS] || '') !== attrs[ATTR_PAYS]) {
        throw new Error('pickup point not saved');
      }
      return cart;
    });
    enCours = requete;
    function liberer() {
      if (enCours !== requete) return;
      enCours = null;
      if (express) express.inert = etaitInerte;
    }
    requete.then(liberer, liberer);
    return requete;
  }

  // Le choix reste facultatif. Seule une sauvegarde deja lancee est attendue.
  document.addEventListener('click', function (e) {
    var bouton = e.target.closest && e.target.closest('[data-vd-cart-checkout]');
    if (!bouton || !enCours) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (bouton.getAttribute('aria-busy') === 'true') return;
    var attente = enCours;
    bouton.setAttribute('aria-busy', 'true');
    attente.then(function () {
      bouton.removeAttribute('aria-busy');
      if (document.documentElement.contains(bouton)) bouton.click();
    }, function () {
      bouton.removeAttribute('aria-busy');
      var erreur = document.querySelector('.vd-pr [role="alert"]');
      if (erreur) erreur.focus();
    });
  }, true);

  function monter(ancre) {
    if (document.querySelector('.vd-pr')) return;
    if (!paysAvecRelais()) { nettoyerSiSansRelais(); return; }
    styles();

    var T = libellesDepuisLiquid(ancre) || LANGUES[lang] || LANGUES.fr;

    var bloc = document.createElement('div');
    bloc.className = 'vd-pr';
    bloc.hidden = true;
    ancre.insertAdjacentElement('afterend', bloc);

    var etat = { points: [], choisi: null };

    function sauvegarder(valeur, libelle, retour) {
      if (enCours) return;
      bloc.setAttribute('aria-busy', 'true');
      var message = document.createElement('p');
      message.className = 'vd-pr__msg';
      message.setAttribute('role', 'status');
      message.textContent = T.sauvegarde || T.recherche;
      bloc.appendChild(message);
      enregistrer(valeur).then(function () {
        etat.choisi = libelle;
        retour();
      }).catch(function () {
        message.setAttribute('role', 'alert');
        message.setAttribute('tabindex', '-1');
        message.textContent = T.erreur_sauvegarde || T.erreur;
      }).then(function () { bloc.removeAttribute('aria-busy'); });
    }

    function vueRepliee() {
      bloc.innerHTML =
        '<p class="vd-pr__intro">' + ech(T.intro) +
        '<button type="button" class="vd-pr__lien" data-ouvrir>' + ech(T.choisir) + '</button></p>';
      bloc.querySelector('[data-ouvrir]').addEventListener('click', vueRecherche);
    }

    function vueChoisi() {
      bloc.innerHTML =
        '<p class="vd-pr__actif"><b>' + ech(T.choisi) + '</b><br>' + ech(etat.choisi) +
        '<br><button type="button" class="vd-pr__lien" data-ouvrir>' + ech(T.modifier) +
        '</button> <button type="button" class="vd-pr__lien" data-retirer>' +
        ech(T.retirer) + '</button></p>';
      bloc.querySelector('[data-ouvrir]').addEventListener('click', vueRecherche);
      bloc.querySelector('[data-retirer]').addEventListener('click', function () {
        sauvegarder('', null, vueRepliee);
      });
    }

    function vueRecherche() {
      bloc.innerHTML =
        '<p class="vd-pr__intro">' + ech(T.intro) + '</p>' +
        '<form class="vd-pr__form" novalidate>' +
        '<input type="text" name="q" autocomplete="postal-code" placeholder="' +
        ech(T.placeholder) + '" aria-label="' + ech(T.placeholder) + '">' +
        '<button type="submit">' + ech(T.chercher) + '</button></form>' +
        '<div data-resultats></div>';
      var form = bloc.querySelector('form');
      var zone = bloc.querySelector('[data-resultats]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = form.q.value.trim();
        if (q.length < 3) return;
        zone.innerHTML = '<p class="vd-pr__msg">' + ech(T.recherche) + '</p>';
        fetch(API + '?adresse=' + encodeURIComponent(q) + '&pays=' + encodeURIComponent(paysCourant()), { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('pickup search ' + r.status);
            return r.json();
          })
          .then(function (d) {
            etat.points = (d && d.points) || [];
            if (!etat.points.length) {
              zone.innerHTML = '<p class="vd-pr__msg">' + ech(T.rien) + '</p>';
              return;
            }
            var html = '<ul class="vd-pr__liste">';
            etat.points.forEach(function (p, i) {
              var type = p.type === 'consigne' ? T.consigne : T.commerce;
              html += '<li><button type="button" class="vd-pr__pt" data-i="' + i + '">' +
                '<b>' + ech(p.nom) + '</b><span>' + ech(p.adresse) + ', ' +
                ech(p.code_postal) + ' ' + ech(p.ville) + ' &middot; ' +
                ech(String(p.km).replace('.', ',')) + ' km &middot; ' + ech(type) +
                '</span></button></li>';
            });
            zone.innerHTML = html + '</ul>';
            Array.prototype.forEach.call(zone.querySelectorAll('[data-i]'), function (b) {
              b.addEventListener('click', function () {
                var p = etat.points[Number(b.dataset.i)];
                if (!p) return;
                var libelle = p.nom + ', ' + p.adresse + ', ' + p.code_postal + ' ' + p.ville;
                sauvegarder(p.id + ' | ' + libelle, libelle, vueChoisi);
              });
            });
          })
          .catch(function () {
            zone.innerHTML = '<p class="vd-pr__msg">' + ech(T.erreur) + '</p>';
          });
      });
    }

    function sync() {
      if (enCours) return;
      fetch(urlPanier('cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!paysAvecRelais() || !cart || !cart.requires_shipping || !cart.item_count) {
            bloc.hidden = true;
            return;
          }
          bloc.hidden = false;
          if (enCours) return;
          if (cart.attributes && cart.attributes[ATTR_PAYS] && cart.attributes[ATTR_PAYS] !== paysCourant()) {
            enregistrer('').then(function () { etat.choisi = null; vueRepliee(); }).catch(function () {});
            return;
          }
          var v = (cart.attributes && cart.attributes[ATTR]) || '';
          var libelle = v.indexOf(' | ') !== -1 ? v.split(' | ').slice(1).join(' | ') : '';
          if (libelle && libelle !== etat.choisi) {
            etat.choisi = libelle;
            vueChoisi();
          } else if (!libelle && !bloc.querySelector('form') && !bloc.querySelector('[data-ouvrir]')) {
            vueRepliee();
          }
        })
        .catch(function () {});
    }

    vueRepliee();
    sync();

    var corps = document.querySelector('[data-vd-cart-body]');
    if (corps && 'MutationObserver' in window) {
      new MutationObserver(function () { sync(); }).observe(corps, { childList: true });
    }
  }

  /* Un visiteur qui a choisi un relais en France puis bascule sur un pays sans
   * relais garde l'attribut dans son panier : il partirait sur la commande et
   * le failover s'en servirait. On l'efface, une seule fois, sans rien afficher. */
  function nettoyerSiSansRelais() {
    fetch(urlPanier('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.attributes && cart.attributes[ATTR]) enregistrer('');
      })
      .catch(function () {});
  }

  function demarrer() {
    var ancre = document.querySelector('[data-vd-cart-pro]');
    if (ancre) { monter(ancre); return true; }
    return false;
  }

  if (!demarrer()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', demarrer);
    } else {
      var essais = 0;
      var t = setInterval(function () {
        if (demarrer() || ++essais > 20) clearInterval(t);
      }, 500);
    }
  }
})();
